import React, { FunctionComponent } from "react"
import ratmService from "../../../utils/RATMService"
import "./RoleManagementTableContextMenu.css"

interface Props {
    index: number
    PortalRoleId: number
}

const RoleManagementTableContextMenu: FunctionComponent<Props> = (props) => {

    const { index, PortalRoleId } = props
    const { manageState } = ratmService

    return (
        <div id={`e837f90554d4f6884a7f5a89da61f17-${index}`} className="RoleManagementTableContextMenu">
            <div className="RoleManagementTableContextMenuItem">
                <span
                    className="material-icons cb6a443cc44a6928e9bf51f67fc91"
                    onClick={() => manageState([{ key: "addOrEditRoleId", value: PortalRoleId }])}
                >edit</span>
            </div>
            <div className="RoleManagementTableContextMenuItem">
                <span
                    className="material-icons f2f0960ec7ef40099aded5a3bf27774b"
                    onClick={() => manageState([{ key: "deleteRoleId", value: PortalRoleId }])}
                >delete</span>
            </div>
        </div>
    )
}

export default RoleManagementTableContextMenu